import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import IntrabankForm from '../../components/transfer/IntrabankForm';
import Storage from '../../services/Storage';

export default function Intrabank() {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (Storage.getLocalAccessToken() === null) {
      navigate('/signin', { replace: true })
    }
  }, [navigate])
  return (
    <IntrabankForm />
  );
}